<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-16 17:48:07
 * @LastEditTime: 2019-09-20 13:24:32
 * @LastEditors: Please set LastEditors
 -->
<template>
<div id='page_Container'>
    <div class="page">
        <div id='main-container' class="temporaryHeight main-container">
            <div id="publicityPage" :class="posterClass" v-if="pageShow">
                <img :src="posterImage" alt="" class="bgimg">
                <div class="btn-join" @click="join">{{btnTitle}}</div>
                <div id="qrcode"></div>
                <van-popup v-model="show">
                    <img src="../assets/img/fenxiao/haibao.jpg" alt="" class="bg">
                    <!-- <canvas id="shareImg"></canvas> -->
                </van-popup>
                <div class='invitationCode' v-if='isDistribution'>
                    <div>
                        我的邀请码
                    </div>
                    <div>
                        <span id='spanId'>{{accountInvitationCode}}</span>
                        <span @click="copyText">点我复制</span>
                    </div>
                </div>
                <van-popup v-model="shadowShow" class='shadow'>
                    <div class='shadow' v-show='shadowShow'>
                        <img :src="shadowPicZx" alt="" class='shadowPicZx'>
                        <img :src="shadowPicZxText" alt="" class='shadowPicZxText'>
                        <div class='shadowBtn'>
                            <div>
                                <van-button type="primary" class='btnColor1' @click="makePic">生成海报</van-button>
                            </div>
                            <div>
                                <van-button type="primary" class='btnColor2' @click="cancelShadow">取消</van-button>
                            </div>
                        </div>
                    </div>
                </van-popup>

            </div>
        </div>
    </div>
</div>
</template>

<script>
import QRCode from 'qrcodejs2';
import { Toast } from 'vant';
import { toastLoading, clearToastLoading } from '../utils/base/utils';
import { wxCircle, wxFriends } from '@/base/share.js';
export default {
    data() {
        return {
            show: false,
            pageShow: false,
            count: 0,
            qrcodeImg: {},
            shareImage: require('@/assets/img/fenxiao/sharefriend.jpg'),
            joinImage: require('@/assets/img/fenxiao/gojoin.jpg'),
            isDistribution: null,
            btnTitle: '',
            shadowShow: false,
            shadowPicZx: require('../assets/img/goods/planzx.png'),
            shadowPicZxText: require('../assets/img/goods/planText.png'),
            accountInvitationCode: '',
            invotationShow: false,
            link: '',
            shadowHeight: 0,
            merchantCode: '',
            // shareImg: require('@/assets/img/fenxiao/shareImg.jpg')
            shareImg: 'http://osmgas.oss-cn-shenzhen.aliyuncs.com/20190925165318404827.jpg'
        };
    },
    esvReady() {
        this.isDistribution = this.$route.params.isDistribution;
        if (this.ESVBase.isEmpty(this.isDistribution)) {
            this.isDistribution = this.ESVStorage.getSavedValue('isDistribution');
        }
        this.btnTitle = this.isDistribution ? '邀请好友 赚大钱' : '立即加入';
        this.getMerchantInfo();
    },
    esvShow() {
        // this.shadowHeight = document.body.clientHeight + 'px';
        console.log(document.body.clientWidth);
    },
    destroyed() {},
    methods: {
        queryMemberAccount() {
            const ths = this;
            this.$doRequest(
                {
                    url: '/account/queryMemberAccount',
                    params: {},
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        // ths.loading = false;
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    const url = ths.getBaseUrl() + '#/OPOpenDistribution' + '?code=' + data.result.accountInvitationCode;
                    ths.accountInvitationCode = data.result.accountInvitationCode;
                    ths.pageShow = true;
                    ths.getShortOauthUrl(url, ths.merchantCode);
                }
            );
        },
        drowcanvas(bgimg, qrimg) {
            const canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            qrimg = document.querySelector('#qrcode canvas');
            const devicePixelRatio = window.devicePixelRatio || 1;
            const backingStoreRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
            const ratio = devicePixelRatio / backingStoreRatio;
            // ratio = 3;
            const cW = bgimg.width;
            const cH = bgimg.height;
            console.log(cW, cH);

            canvas.width = cW * ratio;
            canvas.height = cH * ratio;
            context.scale(ratio, ratio);
            bgimg.style.display = 'none';
            console.log(canvas.width, canvas.height, ratio, cW / cH);
            context.drawImage(bgimg, 0, 0, cW, cH);
            // let bgRatio = cW / cH;
            // let qrW = 53.5 / bgRatio;
            const qrW = 1 * cW * 0.29;
            const qrH = qrW;
            const qrX = (cW - qrW) / 2;
            const qrY = cH * 0.71;
            context.drawImage(qrimg, qrX, qrY, qrW, qrH);
            // context.drawImage(qrimg, 38 * ratio, 136 * ratio, 32 * ratio, 32 * ratio);

            const img = this.convertCanvasToImage(canvas);

            document.querySelector('.van-popup').appendChild(img);
            // document.querySelector('.van-popup').appendChild(canvas);
            // canvas.style.display = 'none';
        },
        convertCanvasToImage(canvas) {
            var image = new Image();
            image.src = canvas.toDataURL('image/png');
            return image;
        },
        qrcode() {
            const bg = document.querySelector('.bg');
            bg.onload = () => {
                const qr = document.querySelector('#qrcode canvas');
                this.drowcanvas(bg, qr);
            };
        },
        cancelShadow() {
            this.shadowShow = false;
        },
        makePic() {
            this.show = true;
            this.$nextTick(() => {
                if (this.count === 0) {
                    this.qrcode();
                    this.count = 1;
                }
            });
        },
        join() {
            if (this.isDistribution) {
                // 生成分享海报
                this.shadowShow = true;
            } else {
                // 进入分销开通页面
                this.esvOpenPage('OPOpenDistribution');
            }
        },
        getBaseUrl() {
            return window.location.href.split('#')[0];
        },
        getMerchantInfo() {
            const ths = this;
            ths.$doRequest(
                {
                    url: '/merchant/getMerchantInfo',
                    params: {},
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function (data) {
                    ths.merchantCode = data.result.merchantCode;
                    ths.queryMemberAccount();
                }
            );
        },
        getShortOauthUrl(url, merchantCode) {
            const ths = this;
            ths.$doRequest(
                {
                    url: '/oauth/getShortOauthUrl',
                    params: {
                        url,
                        merchantCode
                    }
                },
                function (data) {
                    ths.link = data.result;
                    const qrcode = new QRCode('qrcode', {
                        width: 310,
                        height: 310,
                        text: ths.link, // 二维码地址
                        colorDark: '#000',
                        colorLight: '#fff'
                    });
                    console.log(qrcode);
                    ths.invotationShow = true;

                    ths.onMenuFriend();
                }
            );
        },
        copyText() {
            var copyDOM = document.getElementById('spanId');
            var range = document.createRange();
            window.getSelection().removeAllRanges();
            range.selectNode(copyDOM);
            window.getSelection().addRange(range);
            var successful = document.execCommand('copy');
            if (successful) {
                Toast('已复制');
            }
            // 移除选中的元素
            window.getSelection().removeAllRanges();
        },
        onMenuFriend () {
            wxCircle('微分销招募令', this.link, this.shareImg, 'fenxiao');
            wxFriends('微分销招募令', '我出本金，给你做生意！注册分销员，大家一起赚！', this.link, this.shareImg);
        }
    },
    computed: {
        posterImage() {
            if (this.isDistribution) {
                return this.shareImage;
            } else {
                return this.joinImage;
            }
        },
        posterClass() {
            if (this.isDistribution) {
                return {
                    shareClass: true
                };
            } else {
                return {
                    joinClass: true
                };
            }
        }
    },
    esvBack(backFn) {
        this.ESVStorage.getSessionValue('baseSession', (data) => {
            const { merchantCode, link, wechatTitle } = { ...data };
            if (merchantCode && link && wechatTitle) {
                wxCircle(wechatTitle, link, 'http://osmgas.oss-cn-shenzhen.aliyuncs.com/20190925165318404827.jpg', 'home remove');
                wxFriends(wechatTitle, '', link, 'http://osmgas.oss-cn-shenzhen.aliyuncs.com/20190925165318404827.jpg');
            }
        });
        return backFn && backFn(true);
    }
};
</script>

<style lang="scss">
    #publicityPage {
        width: 100%;
        position: relative;

        min-height: 100%;
        .bgimg {
            width: 100%;
            display: block;
        }
        .van-popup {
            width: 80%;
            background-color: transparent;
            // height: 90%;
            img:nth-child(2) {
                width: 100%;
                display: block;
                // height: 100%;
            }
        }
        .van-popup.shadow {
            width: 100%;
            img:nth-child(2) {
                width: 198px;
                display: block;
                // height: 100%;
            }
        }
        .btn-join {
            position: absolute;
            // bottom: 35px;
            text-align: center;
        }
        #qrcode {
            // visibility: hidden;
            position: absolute;
            top: 0;
            z-index: -1;
            // width: 200px;
            // height: 200px;
            // canvas {
            //     display: block !important;
            // }
            // img {
            //     display: none !important;
            // }
        }
        // #shareImg {
        //     visibility: hidden;
        //     // width: 100%;
        //     // height: 100%;
        // }
        .bg {
            width:100%;
            height: 100%;
            visibility: hidden;
        }
    }
    .shareClass {
        background-color: #ff9000;
        .btn-join {
            bottom: 35px;
            width: 82%;
            margin-left: 9%;
            height: 43px;
            font-size: 23px;
            border-radius: 15px;
            text-align: center;
            line-height: 43px;
            background: linear-gradient(180deg, #ffe96f 0%, #ffc500, 80%, #ff9000 100%);
            color: #fe0901;
            box-shadow: 5px 5px 5px #ff7e00, -5px 5px 5px #ff7e00 ;
        }
    }
    .joinClass {
       background-color: #fd254e;
        .btn-join {
            bottom: 52px;
            width: 52%;
            margin-left: 24%;
            height: 36px;
            font-size: 23px;
            border-radius: 6px;
            text-align: center;
            line-height: 36px;
            font-size: 14px;
            background: #ffde49;
            color: #fb2f4e;
            font-weight: 700;
        }
    }
    .invitationCode{
        width: 100%;
        background: rgba(0,0,0,.6);
        position: absolute;
        left: 0;
        top: 0;
        height:50px;
        line-height: 50px;
        color:#fff;
        padding:0 12px;
        div:nth-child(1){
            float: left;
        }
        div:nth-child(2){
            float: right;
            span:nth-child(2){
                padding:4px 10px;
                margin-left:5px;
                border:1px solid #fff;
                border-radius: 15px;
            }
        }
    }
</style>
